import React from 'react'
import reactLogo from '../img/react.png'
import cssLogo from '../img/css.png'
import angularLogo from '../img/angular.png'
import htmlLogo from '../img/html.png'
import jqueryLogo from '../img/jquery.png'
import bootstrapLogo from '../img/bootstrap.png'
import nodeLogo from '../img/node.png'
import electronLogo from '../img/electron.png'
import gitLogo from '../img/git.png'
import JavaScriptLogo from '../img/JavaScript.png'
import laravelLogo from '../img/laravel.png'
import mayaLogo from '../img/maya.png'
import mongoLogo from '../img/mongo.png'
import mysqlLogo from '../img/mysql.png'
import xdLogo from '../img/xd.png'
import photoshopLogo from '../img/photoshop.png'
import phpLogo from '../img/php.png'
import pythonLogo from '../img/python.png'
const SkillsSection = class extends React.Component {
    onClick = (e) => {
        e.preventDefault()
      }
    render() {
        return (
            <section className="elementor-section skill-section">
                <div className="elementor-container">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href='https://www.w3schools.com/' onClick={this.onClick}> 
                                    <img className="art-brand" src={htmlLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>HTML 5</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href='https://www.w3schools.com/' onClick={this.onClick}> 
                                    <img className="art-brand" src={cssLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>CSS 3</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://getbootstrap.com/"> 
                                    <img className="art-brand" src={bootstrapLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Bootstrap</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href='https://www.w3schools.com/' onClick={this.onClick}> 
                                    <img className="art-brand" src={JavaScriptLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>JavaScript</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://jquery.com/"> 
                                    <img className="art-brand" src={jqueryLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Jquery</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://www.electronjs.org/"> 
                                    <img className="art-brand" src={electronLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>ElectronJs</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://angular.io/"> 
                                    <img className="art-brand" src={angularLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Angular</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://reactjs.org/"> 
                                    <img className="art-brand" src={reactLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>React</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://nodejs.org"> 
                                    <img className="art-brand" src={nodeLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>NodeJs</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href='https://www.w3schools.com/' onClick={this.onClick}> 
                                    <img className="art-brand" src={pythonLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Python</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://laravel.com/"> 
                                    <img className="art-brand" src={laravelLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Laravel</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://www.php.net/"> 
                                    <img className="art-brand" src={phpLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Php</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://www.mysql.com/"> 
                                    <img className="art-brand" src={mysqlLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>MySQL</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://www.mongodb.com/"> 
                                    <img className="art-brand" src={mongoLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>MongoDB</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://git-scm.com/"> 
                                    <img className="art-brand" src={gitLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Git</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://www.adobe.com/products/xd.html"> 
                                    <img className="art-brand" src={xdLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Adobe Xd</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://www.adobe.com/products/photoshop.html"> 
                                    <img className="art-brand" src={photoshopLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Photoshop</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                            <div className=" col-6 col-md-3 col-lg-2 art-skill">
                                <a target="_blank" rel="noreferrer" href="https://www.autodesk.com/products/maya"> 
                                    <img className="art-brand" src={mayaLogo} alt="Brand 2" />
                                    <div className="art-text">
                                        <p><span>&lt;<i>Maya</i>/&gt;</span></p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default SkillsSection